export default "__VITE_ASSET__DgGMaEsy__"